import { Button, Text } from '@mantine/core';
import { IconLink, IconPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import styles from './EmptyLinkedEntitiesState.module.scss';
import { Props } from './EmptyLinkedEntitiesState.types';

const EmptyLinkedEntitiesState = ({ onAddClick }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <IconLink size={28} className={styles.icon} />
      <span className={styles.title}>{t('entityLinks.empty.title', 'Aucun élément lié')}</span>
      <Text size="sm" c="dimmed" ta="center">
        {t(
          'entityLinks.empty.subtitle',
          "Liez des actions, contacts ou dépenses à cette fiche pour tout retrouver d'un coup d'œil."
        )}
      </Text>
      <Button size="xs" variant="light" leftSection={<IconPlus size={14} />} onClick={onAddClick}>
        {t('entityLinks.empty.cta', 'Lier un élément')}
      </Button>
    </div>
  );
};

export default EmptyLinkedEntitiesState;
